/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spicy_Busy_Opossum_RoamInputs */

const fr_spicy_busy_opossum_roam = /** @type {(inputs: Spicy_Busy_Opossum_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

/**

* @param {Spicy_Busy_Opossum_RoamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spicy_busy_opossum_roam = /** @type {((inputs?: Spicy_Busy_Opossum_RoamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spicy_Busy_Opossum_RoamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spicy_busy_opossum_roam(inputs)
});